import { color } from "style/constants";

export default {
  root: {
    backgroundColor: color.WHITE
  },
  indicator: {
    height: 5
  }
};
